<template>
  <div class="container">
    <header class="jumbotron">
      <h3>Saldos</h3>
    </header>

    <Form @submit="handleFilter" :validation-schema="schema">
      <div class="col-md-5">
        <div class="card card-container">
          <div v-if="!successful">
            <div class="form-group">
              <label for="user">Usuário</label>
              <Field name="user" as="select" class="form-control">
                <option value="">Selecione um usuário</option>
                <option
                  v-for="i in userOptions"
                  :value="i.value"
                  :key="i.value"
                >
                  {{ i.text }}
                </option>
              </Field>
              <ErrorMessage name="user" class="error-feedback" />
            </div>
            <div class="form-group">
              <label for="datestart">Data Inicio (AAAA-MM-DD)</label>
              <Field name="datestart" type="text" class="form-control" />
              <ErrorMessage name="datestart" class="error-feedback" />
            </div>
            <div class="form-group">
              <label for="dateend">Data Fim (AAAA-MM-DD)</label>
              <Field name="dateend" type="text" class="form-control" />
              <ErrorMessage name="dateend" class="error-feedback" />
            </div>
            <div class="form-group">
              <button class="btn btn-primary btn-block" :disabled="loading">
                <span
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                ></span>
                Filtrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Form>
    <table>
      <thead>
        <tr>
          <th>Usuário</th>
          <th>Tipo</th>
          <th>Data</th>
          <th style="text-align: right; text-wrap: nowrap">
            Valor (R$ {{ total.toFixed(2) }})
          </th>
        </tr>
      </thead>
      <tbody style="font-size: 13px">
        <tr v-for="(row, index) in rows" :key="`balance-${index}`">
          <td>{{ row.user }}</td>
          <td>{{ row.type }}</td>
          <td style="text-wrap: nowrap">{{ row.date }}</td>
          <td style="text-align: right; text-wrap: nowrap">
            R$ {{ row.value.toFixed(2) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import BalanceService from "../services/balance.service";
import UserService from "../services/user.service";
import { Form, Field, ErrorMessage } from "vee-validate";

import * as yup from "yup";

export default {
  name: "Balances",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({});
    return {
      date: null,
      successful: false,
      loading: false,
      perPage: 3,
      currentPage: 1,
      filter: "",
      schema,
      rows: [],
      userOptions: [],
      total: 0,
    };
  },
  mounted() {
    if (!this.currentUser || !this.loggedIn) {
      this.$root.logOut();
    }
    if (this.loggedIn) {
      UserService.getListUser().then(
        (response) => {
          if (response.data.result) {
            this.userOptions = response.data.data;
          }
        },
        (error) => {
          this.userOptions = [];
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
          this.$root.logOut();
        }
      );
      BalanceService.getBalances().then(
        (response) => {
          if (response.data.result) {
            this.rows = response.data.data;
            this.total = this.rows.reduce((a, b) => a + b.value, 0);
          }
        },
        (error) => {
          this.rows = [];
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
          this.$root.logOut();
        }
      );
    }
  },
  computed: {
    loggedIn() {
      return (
        this.$store.state.auth.status.loggedIn &&
        this.$store.state.auth.user.validOTP
      );
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    handleFilter(data) {
      BalanceService.getBalancesFiltered(data).then(
        (response) => {
          if (response.data.result) {
            this.rows = response.data.data;
            this.total = this.rows.reduce((a, b) => a + b.value, 0);
          }
        },
        (error) => {
          this.rows = [];
          confirm.error(error);
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
          this.$root.logOut();
        }
      );
      this.message = "";
      this.successful = false;
      this.loading = false;
    },
  },
};
</script>
<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

th {
  background-color: #dddddd;
}
</style>